import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';

const sadidleeRoutes = {
	path: 'sadidlee',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.SADIDLEE,
	},
	children: [
		{
			path: 'upload-packages',
			component: () => import('./pages/upload-packages/index.vue'),
			meta: {
				title: t('sadidlee.upload-packages'),
			},
		},
	],
};

export { sadidleeRoutes };

